module.exports = __webpack_public_path__ + "img/smiling.8a897f96.png";